module.exports = __webpack_public_path__ + "static/media/mark.de76a277.jpg";